var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"municipalities-list__item"},[_c('div',[_vm._v(_vm._s(_vm.municipality.geo_code))]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":_vm.municipality.url}},[_vm._v(_vm._s(_vm.municipality.name))])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de76fec8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/vue/municipalities-item.vue
// module id = cJaV
// module chunks = 0